import React from 'react'
import PropTypes from "prop-types";


function P2Radio({gap=10, type="dot", variant="default", isActive=false, ...props}) {
  return (
    <div className='polymer-radio-form' style={{gap:gap, flexDirection: variant === "reverse" ? 'row-reverse' : undefined}}>
      <div onClick={props.onClick}  className={`polymer-radio-form__icon 
        ${(variant === "default" || variant === "reverse") && isActive && type === "dot" ? 'active' : variant === "disabled" ? 'disabled' : ''} 
        ${(variant === "default" || variant === "reverse") && isActive && type === "tick" ? 'active-tick' : variant === "disabled" ? 'disabled' : ''}`}
      >
        
        {type === "dot" && (variant === "default" || variant === "reverse") && isActive && <div className='polymer-radio-form__icon-active'/>}
        
        {type === "tick" && (variant === "default" || variant === "reverse") && isActive && 
        <div className='polymer-radio-form__icon-active-tick'>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>}

      </div>
      {props.description && <div className='polymer-radio-form__description' >{props.description ? props.description : undefined}</div>}
    </div>
  )
}

export default P2Radio

P2Radio.propTypes = {
  variant: PropTypes.oneOf(['default', 'reverse', 'disabled']),
  type: PropTypes.oneOf(['dot', 'tick']),
  isActive: PropTypes.bool,
  description: PropTypes.oneOfType([
    PropTypes.string,
    // undefined,
    PropTypes.element
  ]),
  onClick: PropTypes.func,
  gap: PropTypes.number
}


P2Radio.defaultProps = {
  variant:'default',
  gap: 10,
  type: 'dot',
  isActive: false
};